export default __webpack_public_path__ + "static/media/css_3.bc79d17c.svg";